import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Command, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { ControlDataExportCommand } from '../../../rent/command/control-data-export.command';
import { ControlDataFormService } from '../../../rent/service/data/control-data-form.service';
import { NativeWindowService } from '../../../core/service/native-window.service';

@Injectable()
export class PrintControlDataCommandHandler implements ICommandHandler {
  constructor(
    private _service: ControlDataFormService,
    private _nativeWindow: NativeWindowService
  ) {}

  canExecute(command: Command): boolean {
    if (command instanceof MultiselectCommand) {
      return command.id === ControlDataExportCommand.printToPdf && command.itemsSource.length > 0;
    }
    return false;
  }

  execute(command: Command): Observable<boolean> {
    if (command instanceof MultiselectCommand) {
      if (command.id === ControlDataExportCommand.printToPdf) {
        return this._service.OrderPdfPrint(command.items.map(item => item.id)).pipe(
          map(res => {
            this._nativeWindow.save(res);
            return true;
          })
        );
      }
    }
  }
}
